module.exports = __webpack_public_path__ + "img/GAME_RAINWINDOW1.63a7b841.jpg";